/* 陸遜傳共用的小工具：山越、夷兵、史書上有名但不是可選武將的人、帶兵、生擒，以及牙幢、鼓角、葑豆田、棋盤、射垛的畫法
 * （只給 luxun*.ts 用；機制寫在這裡，不動 campaign/kit.ts） */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop, TROOPS } from '../kit.ts';

// 山越（丹楊山民）、夷兵（宜都、秭歸的蠻夷）
export const SHANYUE = troop('lx-shanyue', '山越', { armor: '#4e5a3a', sleeve: '#3a4430', cloth: '#3a4430', plume: '#8a9a5a', metal: '#6a6a60' });
export const YIBING = troop('lx-yibing', '夷兵', { armor: '#7a4a3a', sleeve: '#5a3428', cloth: '#5a3428', plume: '#c08050' });
export const WEI = TROOPS.wei, SHU = TROOPS.shu, WU = TROOPS.wu;

// 不是可選武將的人：通用招式；faction 照勢力上色（中立的人墊一套暗色的底）
const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, faction, role, weapon, look, n) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look, faction === 'neutral' ? { c: Object.assign({}, NEUTRAL_C, look.c) } : {}), [
  ['揮擊', 'crescent', `造成 {${n}/${n}/${n}/${n}} 傷害。`], ['衝陣', 'charge', `衝撞造成 {${n}/${n}/${n}/${n}} 傷害。`], ['迴斬', 'spin', `每圈 {${n >> 1}/${n >> 1}/${n >> 1}/${n >> 1}} 傷害。`], ['猛擊', 'slam', `{${n * 1.5}/${n * 1.5}/${n * 1.5}} 傷害。`]]);
const SYC = { armor: '#4e5a3a', cloth: '#3a4430', cape: '#5a6a40', plume: '#8a9a5a', band: '#8a9a5a' };
const YIC = { armor: '#7a4a3a', cloth: '#5a3428', cape: '#9a5a3a', plume: '#c08050', band: '#c08050' };
const SHUC = { armor: '#3e7b50', cloth: '#2e5a3a', cape: '#3e7b50', plume: '#7ab08a' };
export const MEN = {
  feizhan: P('lx-feizhan', '費棧', '丹楊賊帥', 'neutral', '戰士', 'axe', { head: 'headband', eye: 'fierce', beard: 'bushy', bulk: 1.2, size: 1.15, c: SYC }, 90),
  fanyou: P('lx-fanyou', '樊友', '劉備宜都太守', 'neutral', '謀士', 'sword', { head: 'guan', beard: 'goatee', c: SHUC }, 40),
  zhanyan: P('lx-zhanyan', '詹晏', '蜀將', 'neutral', '戰士', 'spear', { beard: 'mustache', bulk: 1.1, c: SHUC }, 80),
  chenfeng: P('lx-chenfeng', '陳鳳', '蜀將', 'neutral', '戰士', 'sword', { beard: 'bushy', bulk: 1.1, c: SHUC }, 80),
  wenbu: P('lx-wenbu', '文布', '秭歸大姓', 'neutral', '戰士', 'axe', { eye: 'fierce', beard: 'bushy', bulk: 1.15, c: YIC }, 85),
  dengkai: P('lx-dengkai', '鄧凱', '秭歸大姓', 'neutral', '戰士', 'spear', { beard: 'mustache', c: YIC }, 75),
  xiejing: P('lx-xiejing', '謝旌', '吳將・將步兵', 'wu', '戰士', 'spear', { beard: 'mustache', c: { cape: '#a83a2a' } }, 70),
  zhuhuan: P('lx-zhuhuan', '朱桓', '字休穆・左督', 'wu', '戰士', 'sword', { eye: 'fierce', beard: 'bushy', bulk: 1.15, c: { cape: '#a83a2a' } }, 90),
  quancong: P('lx-quancong', '全琮', '字子璜・右督', 'wu', '戰士', 'spear', { beard: 'goatee', c: { cape: '#a83a2a' } }, 80),
  jiakui: P('lx-jiakui', '賈逵', '豫州刺史', 'wei', '戰士', 'sword', { head: 'guan', beard: 'long' }, 80),
  zhugejin: P('lx-zhugejin', '諸葛瑾', '字子瑜', 'wu', '謀士', 'staff', { head: 'guan', beard: 'long', c: { armor: '#5a3a30', cloth: '#6a2a24', cape: null } }, 40),
};

// 帶一隊兵：n 個跟著 lead 走的兵（m.recruit 的跟隨陣形）
export function band(m, lead, n, name, spec, o) {
  return Array.from({ length: n }, (_, i) => {
    const u = m.recruit(lead.x - 80 - (i % 4) * 50, lead.y - 70 + Math.floor(i / 4) * 80, name);
    if (spec) u.spec = spec;
    Object.assign(u, o || {}); if (o && o.hp) u.maxHp = o.hp;
    m.join(u, lead);
    return u;
  });
}

// 生擒：首領剩 frac 的血就跪下（打不到、不動），旁邊讀條 t 秒生縛；limit 秒內沒縛住就逃走
// 回傳狀態物件；每步呼叫 tickCapture
export function capturable(u, frac = 0.3) { u.capFrac = frac; u.cap = { state: 'fight' }; return u.cap; }
export function tickCapture(m, w, u, o) {
  const C = u.cap;
  if (!C || !u.alive) return C;
  if (C.state === 'fight' && u.hp <= u.maxHp * u.capFrac) {
    C.state = 'kneel'; C.t0 = w.t; u.untargetable = true; u.target = null; u.home = [u.x, u.y]; u.caster = false; u.ms0 = u.ms; u.ms = 0;
    m.big(`${u.name}跪地請降`); m.mark('cap', u.x, u.y, '生縛', false, u);
    if (o.kneel) o.kneel();
  }
  if (C.state === 'kneel') {
    u.target = null; u.think = 0.5;
    if (u.hp < u.maxHp * u.capFrac * 0.5) u.hp = u.maxHp * u.capFrac * 0.5; // 跪下之後不會被誤殺
    m.chanAt(w.player, 'cap', u.x, u.y, 160, o.t || 2, '生縛', () => { C.state = 'bound'; m.unmark('cap'); if (o.bound) o.bound(); }, { hurt: false });
    if (C.state === 'kneel' && w.t - C.t0 > (o.limit || 20)) {
      C.state = 'fled'; m.unmark('cap'); u.ms = 320; u.home = o.flee.slice();
      if (o.fled) o.fled();
      m.after(5, () => { u.alive = false; u.counted = true; u.deadT = w.t; });
    }
  }
  return C;
}

// 夜色
export function night(ctx, x0, y0, vw, vh, a = 0.5) { ctx.fillStyle = `rgba(12,18,48,${a})`; ctx.fillRect(x0, y0, vw, vh); }

// ---- 畫法（給 m.folk 的 draw）----
// 牙幢：高竿上一面長幡，夜裡隨風擺；f.up 還沒插好時畫一根倒在地上的竿
export function drawBanner(ctx, f, T) {
  const { poly, caps } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 16, 5, 60, 0.3);
  if (!f.up) { caps(ctx, [[[-40, -4], [40, -10], 4, '#5b3d27']]); ctx.restore(); return; }
  caps(ctx, [[[0, 0], [0, -150], 5, '#5b3d27']]);
  const s = Math.sin(T * 3 + f.x * 0.01) * 6;
  poly(ctx, [[0, -146], [44 + s, -140], [40 + s * 1.4, -70], [0, -78]], f.col || '#b8433a', 2);
  ctx.fillStyle = '#f2e6c0'; ctx.font = '900 22px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(f.text || '陸', 20 + s * 0.7, -108);
  caps(ctx, [[[-8, -150], [8, -150], 4, '#d9b444']]);
  ctx.restore();
}
// 鼓角：架在木架上的戰鼓，旁邊插一支號角；f.beat 時鼓面閃動
export function drawDrum(ctx, f, T) {
  const { poly, caps } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 26, 7, 60, 0.3);
  if (!f.up) { ctx.beginPath(); ctx.ellipse(0, -10, 22, 12, 0, 0, Math.PI * 2); SG.draw.ink(ctx, '#6a3a22', 2); ctx.restore(); return; }
  caps(ctx, [[[-24, 0], [-18, -40], 4, '#5b3d27'], [[24, 0], [18, -40], 4, '#5b3d27']]);
  ctx.beginPath(); ctx.ellipse(0, -48, 30, 22, 0, 0, Math.PI * 2); SG.draw.ink(ctx, '#8a2a1a', 2.2);
  const k = f.beat ? 0.5 + 0.5 * Math.sin(T * 18) : 0;
  ctx.beginPath(); ctx.ellipse(0, -52, 22, 14, 0, 0, Math.PI * 2); SG.draw.ink(ctx, `rgb(${Math.round(216 + 30 * k)},${Math.round(196 + 30 * k)},150)`, 1.4);
  poly(ctx, [[30, -10], [36, -10], [52, -70], [46, -72]], '#d8c8a0', 1.4);
  ctx.restore();
}
// 葑豆田：一畦土，f.n（0～1）越大苗越多
export function drawPlot(ctx, f, T) {
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.fillStyle = '#6a4a2c'; ctx.beginPath(); ctx.ellipse(0, 0, 90, 34, 0, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = 'rgba(40,26,14,.6)'; ctx.lineWidth = 2;
  for (let r = -20; r <= 20; r += 13) { ctx.beginPath(); ctx.moveTo(-70, r * 0.8); ctx.lineTo(70, r * 0.8); ctx.stroke(); }
  const n = Math.round((f.n || 0) * 18);
  ctx.fillStyle = '#7ab04a';
  for (let i = 0; i < n; i++) { const x = -64 + (i % 6) * 26, y = -18 + Math.floor(i / 6) * 14, s = Math.sin(T * 2 + i) * 1.5; ctx.beginPath(); ctx.ellipse(x + s, y - 6, 4, 7, 0.3, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
// 棋盤：矮几上一張棋枰
export function drawBoard(ctx, f) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 40, 10, 60, 0.3);
  poly(ctx, [[-40, -20], [40, -20], [36, 0], [-36, 0]], '#7a5634', 1.8);
  poly(ctx, [[-34, -36], [34, -36], [40, -20], [-40, -20]], '#d8b878', 1.6);
  ctx.fillStyle = '#1a1a1a'; for (const [x, y] of [[-12, -28], [6, -30], [18, -25]]) { ctx.beginPath(); ctx.arc(x, y, 3, 0, Math.PI * 2); ctx.fill(); }
  ctx.fillStyle = '#f2f0e8'; for (const [x, y] of [[-20, -24], [0, -25], [12, -31]]) { ctx.beginPath(); ctx.arc(x, y, 3, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
// 射垛：草靶
export function drawTarget(ctx, f) {
  const { caps } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 20, 6, 60, 0.3);
  caps(ctx, [[[-10, 0], [-6, -70], 4, '#5b3d27'], [[10, 0], [6, -70], 4, '#5b3d27']]);
  for (const [r, c] of [[26, '#d8c8a0'], [18, '#b8433a'], [10, '#d8c8a0'], [4, '#b8433a']]) { ctx.beginPath(); ctx.arc(0, -64, r, 0, Math.PI * 2); SG.draw.ink(ctx, c, 1.4); }
  ctx.restore();
}
// 船：停在江邊的樓船（只是畫面）
export function drawShip(ctx, f, T) {
  const { poly, caps } = SG.draw, bob = Math.sin(T * 1.6 + f.x * 0.01) * 3;
  ctx.save(); ctx.translate(f.x, f.y + bob);
  poly(ctx, [[-110, -10], [110, -10], [90, 14], [-96, 14]], '#5a3a22', 2.2);
  poly(ctx, [[-70, -10], [40, -10], [40, -46], [-70, -46]], '#7a5634', 1.8);
  poly(ctx, [[-76, -46], [46, -46], [36, -60], [-66, -60]], '#3a2a1a', 1.6);
  caps(ctx, [[[60, -10], [60, -150], 4, '#5b3d27']]);
  poly(ctx, [[62, -144], [104, -132], [100, -70], [62, -76]], '#d8c8a0', 1.6);
  ctx.restore();
}
